import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useNewsbreakBusinessManagerStore = defineStore({
  id: 'newsbreakBusinessManagerStore',
  state: () => ({
    newsbreakBusinessManagers: [],
    newsbreakBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getNewsbreakBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.newsbreakBusinessManagersLoading = true

      try {
        const {data} = await axios.get('newsbreak/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.newsbreakBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.newsbreakBusinessManagersLoading = false
      }
    },

    async createNewsbreakBusinessManager(payload) {
      this.error = null
      this.newsbreakBusinessManagersLoading = true

      try {
        const {data} = await axios.post('newsbreak/business-managers', payload)

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.newsbreakBusinessManagersLoading = false
      }
    },

    async updateNewsbreakBusinessManager(id, payload) {
      this.error = null
      this.newsbreakBusinessManagersLoading = true

      try {
        let {data} = await axios.patch(`newsbreak/business-managers/${id}`, payload)

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.newsbreakBusinessManagersLoading = false
      }
    },

    async updateNewsbreakBusinessManagerProviders(hash, payload) {
      const {data} = await axios.patch(`newsbreak/business-managers/${hash}/providers`, payload)

      return data
    },

    async getNewsbreakProviders(filters = {}) {
      this.error = null
      this.loading = true

      try {
        const {data} = await axios.get('newsbreak/providers', {params: filters})
        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.loading = false
      }
    },
  },
})
